/**
 * AppShell Component - MOBILE ONLY FOR NOW
 * 
 * Mobile: Bottom tab bar, content ABOVE tabs (column layout)
 * 
 * Tablet/Desktop will be separate when we get there.
 */

import React, { useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import { useRouter } from 'expo-router';
import { useStyles } from '../../../hooks/useStyles';
import { NavItem } from './NavConfig';
import { BottomTabBar } from './BottomTabBar';

// =============================================================================
// TYPES
// =============================================================================

export interface AppShellProps {
  activeNavId: string;
  children: React.ReactNode;
  activityBadgeCount?: number;
  hideNavigation?: boolean;
}

// =============================================================================
// COMPONENT - MOBILE ONLY
// =============================================================================

export function AppShell({
  activeNavId,
  children,
  activityBadgeCount = 0,
  hideNavigation = false,
}: AppShellProps) {
  const router = useRouter();
  const { tokens } = useStyles();

  const handleNavPress = useCallback((item: NavItem) => {
    router.push(item.route as any);
  }, [router]);

  return (
    <View style={[styles.container, { backgroundColor: tokens.color.background }]}>
      <View style={styles.content}>
        {children}
      </View>
      {!hideNavigation && (
        <BottomTabBar
          activeTabId={activeNavId}
          onTabPress={handleNavPress}
          activityBadgeCount={activityBadgeCount}
        />
      )}
    </View>
  );
}

// =============================================================================
// STYLES - MOBILE COLUMN LAYOUT
// =============================================================================

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column', // CONTENT ABOVE TABS
  },
  content: {
    flex: 1,
  },
});

export default AppShell;
